import { Toaster, toast } from "sonner";

export { toast };

export function ToastHost() {
  return <Toaster position="top-center" richColors closeButton toastOptions={{ className: "font-sans" }} />;
}
